<div class="menu-content">

  <p class="menu-content-label">
    <span
        [translate]="'action.filter.group_by'"
      class="translate--text"
    ></span>
  </p>
  
  <div class="plus-wrap">

    <div class="menu-content-select-wrap">
        <button class="menu-content-select">{{menuSelectVal}}</button>
        <span class="icon-chevron-down plus-toggle" (click)="togglePlusContent(null,true, $event)"></span>
    </div>

    <div #plusContent class="plus-content">

        <span class="icon-chevron-up plus-toggle" (click)="togglePlusContent(null, false, $event)"></span>
        <ul>
          <li class="plus-item" (click)="togglePlusContent('Aucun',false,$event)">{{'action.filter.none' | translate}}</li>
          <li  class="plus-item" (click)="togglePlusContent('Regroupement',false,$event)">Regroupement</li>
        </ul>
      </div>
      <button class="menu-content-btn-add icon-check"></button>

  </div>

</div>
